import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { environment } from '@environment';
import { ImaginarySrcModule } from '@wizbii/angular-utilities';
import { trackEventWithAtInternet } from '@wizbii/tracking';

@Component({
  selector: 'app-cej-v2-download-app',
  templateUrl: './cej-v2-download-app.component.html',
  styleUrls: ['./cej-v2-download-app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CejV2DownloadAppComponent {
  readonly imgSrc = `${environment.wizbiiImages}/cejv2/cej-logo.jpg`;
  readonly googlePlayBadgeSrc = `${environment.wizbiiImages}/cejv2/googleplay-badge.jpg`;
  readonly appStoreBadgeSrc = `${environment.wizbiiImages}/cejv2/appstore-badge.jpg`;

  readonly trackEvent = trackEventWithAtInternet;
}

@NgModule({
  imports: [ImaginarySrcModule],
  declarations: [CejV2DownloadAppComponent],
  exports: [CejV2DownloadAppComponent],
})
export class CejV2DownloadAppModule {}
